import { Permission } from '../enums';
import { Avatar, Organisation, UserGroup } from '../models';

export interface UserinfoProfile {
  id: string;
  name: string;
  email: string;
  avatar: Avatar;
  organisations: Organisation[];
  registeredAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UserinfoResponse {
  id: string;
  intercom: string | null;
  profile: UserinfoProfile;
}

export interface MeResponse {
  partnerId: string;
  currentOrg: Organisation;
  permissions: Permission[];
  groups: UserGroup[];
  isWarehouseContact: boolean;
}
